import PublishedRota from '../RotaBuilder/screens/PublishedRota'
import useHomeType from 'hooks/useHomeType'

export const PublishedRotaScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return <PublishedRota />
}
